<template>
  <v-flex xs12 sm8 md6 class="main-col">
    <p class="gotham-m guide-title" transition="scale-transition">TRACK Air+ SE</p>
    <p class="gotham-m guide-desc">{{ $t('t4') }}</p>
    <v-card class="lbt-card">
      <v-card-media v-bind:src="require('../images/airplus_se/cover.jpg')" height="270px"></v-card-media>
      <v-card-title primary-title class="card-content" :style="{ marginTop: 0 }">
        <ul id="menu">
          <li @click="$vuetify.goTo('#download')">
            {{ $t('t7') }}
          </li>
          <li @click="$vuetify.goTo('#interface')">
            {{ $t('t8') }}
          </li>
          <li @click="$vuetify.goTo('#first_time')">
            {{ $t('t9') }}
          </li>
          <li @click="$vuetify.goTo('#connect')">
            {{ $t('t10') }}
          </li>
          <li @click="$vuetify.goTo('#poweron_off')">
            {{ $t('t11') }}
          </li>
          <li @click="$vuetify.goTo('#basic_operation')">
            {{ $t('t12') }}
          </li>
          <li @click="$vuetify.goTo('#smart_anc')">
            {{ $t('t13') }}
          </li>
          <!--佩戴贴合度检测-->
          <li @click="$vuetify.goTo('#wear_status_detect')">
            {{ $t('t14') }}
          </li>
          <li @click="$vuetify.goTo('#wear_detect')">
            {{ $t('t15') }}
          </li>
          <li @click="$vuetify.goTo('#sleep')">
            {{ $t('t16') }}
          </li>
          <li @click="$vuetify.goTo('#connect_new_device')">
            {{ $t('t17') }}
          </li>
          <li @click="$vuetify.goTo('#status')">
            {{ $t('t18') }}
          </li>
          <li @click="$vuetify.goTo('#faq')">
            {{ $t('t19') }}
          </li>
          <li @click="$vuetify.goTo('#spec')">
            {{ $t('t20') }}
          </li>
        </ul>
      </v-card-title>
    </v-card>
    <!--下载-->
    <v-card id="download" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t21')}}</p>
        <p class="lbt-content">{{ $t('t22') }}</p>
        <v-layout row justify-center align-center>
          <v-flex xs8>
            <v-layout column align-center>
              <img class="qr-pic" src="../images/qr_download.png">
              <v-btn class="lbt-button" href="http://download.birdytone.com.cn/index.html">Download</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <!--按键及接口说明-->
    <v-card id="interface" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t23')}}</p>
        <img src="../images/airplus_se/interface.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t24') }}</p>
        <p class="lbt-content-dark">* {{ $t('t25') }}</p>
      </v-card-title>
    </v-card>
    <!--首次使用-->
    <v-card id="first_time" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t26')}}</p>
        <img src="../images/airplus_se/first_time.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t27') }}</p>
      </v-card-title>
    </v-card>
    <!--连接-->
    <v-card id="connect" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t28')}}</p>
        <p class="lbt-content-dark">{{ $t('t29') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/connect01.png" />{{ $t('t30') }}</p>
        <p class="lbt-content-light">{{ $t('t31') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t32')}}</p>
        <p class="lbt-content-flex"><img v-if="lang === '简体中文'" src="../images/airplus_se/connect02cn.gif" /><img v-else src="../images/airplus_se/connect02en.gif" />{{ $t('t33') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t34')}}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/connect03.png" />{{ $t('t35') }}</p>
        <p class="lbt-content-light">* {{ $t('t36') }}</p>
      </v-card-title>
    </v-card>
    <!--开关机-->
    <v-card id="poweron_off" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t37')}}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/power_on.png" />{{ $t('t38') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/power_off.png" />{{ $t('t39') }}</p>
      </v-card-title>
    </v-card>
    <!--基本操作-->
    <v-card id="basic_operation" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t40')}}</p>
        <p class="lbt-content-dark">{{ $t('t41') }}</p>
        <img src="../images/airplus_se/gesture_control.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t42') }}</p>
        <p class="lbt-content-light">{{ $t('t43') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t44') }}</p>
        <p class="lbt-content">{{ $t('t45') }}</p>
        <img v-if="lang === '简体中文'" src="../images/airplus_se/tap_function-airplus_se-cn.gif" class="full-pic"/>
        <img v-else src="../images/airplus_se/tap_function-airplus_se-en.gif" class="full-pic"/>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t46') }}</p>
        <img src="../images/airplus_se/function_button.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t47') }}</p>
        <p class="lbt-content">{{ $t('t48') }}</p>
      </v-card-title>
    </v-card>
    <!--降噪调节-->
    <v-card id="smart_anc" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t49') }}</p>
        <p class="lbt-content-dark">{{ $t('t50') }}</p>
        <p class="lbt-content">{{ $t('t51') }}</p>
        <img v-if="lang === '简体中文'" src="../images/airplus_se/anc-manual-airplus_se-cn.gif" class="full-pic"/>
        <img v-else src="../images/airplus_se/anc-manual-airplus_se-en.gif" class="full-pic"/>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t52') }}</p>
        <p class="lbt-content">{{ $t('t53') }}</p>
        <p class="lbt-content">{{ $t('t54') }}</p>
        <img v-if="lang === '简体中文'" src="../images/airplus_se/anc-auto-airplus_se-cn.gif" class="full-pic"/>
        <img v-else src="../images/airplus_se/anc-auto-airplus_se-en.gif" class="full-pic"/>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t55') }}</p>
        <p class="lbt-content">{{ $t('t56') }}</p>
        <p class="lbt-content">{{ $t('t57') }}</p>
        <img v-if="lang === '简体中文'" src="../images/airplus_se/anc-wind-noise-airplus_se-cn.gif" class="full-pic"/>
        <img v-else src="../images/airplus_se/anc-wind-noise-airplus_se-en.gif" class="full-pic"/>
      </v-card-title>
    </v-card>
    <!--佩戴贴合度检测-->
    <v-card id="wear_status_detect" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t58') }}</p>
        <p class="lbt-content">{{ $t('t59') }}</p>
        <p class="lbt-content">{{ $t('t60') }}</p>
        <img v-if="lang === '简体中文'" src="../images/airplus_se/wear-detect-airplus_se-cn.gif" class="full-pic"/>
        <img v-else src="../images/airplus_se/wear-detect-airplus_se-en.gif" class="full-pic"/>
      </v-card-title>
    </v-card>
    <!--佩戴检测-->
    <v-card id="wear_detect" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t61') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/wear_detect1.gif" />{{ $t('t62') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/wear_detect2.gif" />{{ $t('t63') }}</p>
      </v-card-title>
    </v-card>
    <!--休眠-->
    <v-card id="sleep" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t64') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/sleep01.png" />{{ $t('t65') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/sleep02.png" />{{ $t('t66') }}</p>
      </v-card-title>
    </v-card>
    <!--连接新设备-->
    <v-card id="connect_new_device" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t67') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/connect_new_device.gif" />{{ $t('t68') }}</p>
        <!--视频教程-->
        <!--视频不打包，需单独上传至服务器，注意路径-->
        <p class="lbt-content" v-if="lang === '简体中文'"><a style="color:gray;" href="static/img/guide_ios_cn.mp4" target="_blank">{{ $t('t69') }}</a><br/><br/><a style="color:gray;" href="static/img/guide_android_cn.mp4" target="_blank">{{ $t('t70') }}</a></p>
        <p class="lbt-content" v-else><a style="color:gray;" href="static/img/guide_ios_eu.mp4" target="_blank">{{ $t('t69') }}</a><br/><br/><a style="color:gray;" href="static/img/guide_android_eu.mp4" target="_blank">{{ $t('t70') }}</a></p>
      </v-card-title>
    </v-card>
    <!--状态指示-->
    <v-card id="status" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t71')}}</p>
        <img src="../images/airplus_se/status_indication01.png" class="full-pic"/>
        <p class="lbt-content">{{ $t('t72') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t73') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/status_indication02.gif" />{{ $t('t74') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/status_indication03.gif" />{{ $t('t75') }}<br/>{{ $t('t76') }}<br/>{{ $t('t77') }}<br/>{{ $t('t78') }}<br/>{{ $t('t79') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/status_indication04.gif" />{{ $t('t80') }}</p>
        <p class="lbt-content-light">{{ $t('t81') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t82') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/status_indication05.png" />{{ $t('t83') }}</p>
        <p class="lbt-content-flex"><img src="../images/airplus_se/status_indication06.png" />{{ $t('t84') }}</p>
      </v-card-title>
    </v-card>
    <!--常见问题-->
    <v-card id="faq" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t85')}}</p>
        <p class="lbt-content-dark">{{ $t('t86') }}</p>
        <p class="lbt-content">{{ $t('t87') }}</p>
        <p class="lbt-content">{{ $t('t88') }}</p>
        <p class="lbt-content">{{ $t('t89') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t90') }}</p>
        <p class="lbt-content">{{ $t('t91') }}</p>
        <p class="lbt-content-light">{{ $t('t92') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t93') }}</p>
        <p class="lbt-content">{{ $t('t94') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t95') }}</p>
        <p class="lbt-content">{{ $t('t96') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t97') }}</p>
        <p class="lbt-content">{{ $t('t98') }}</p>
        <p class="lbt-content-light">{{ $t('t99') }}</p>
      </v-card-title>
    </v-card>
    <!--产品参数-->
    <v-card id="spec" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t100')}}</p>
        <p class="lbt-content-dark">{{ $t('t101') }}</p>
        <p class="lbt-content">{{ $t('t102') }}</p>
        <p class="lbt-content-dark">{{ $t('t103') }}</p>
        <p class="lbt-content">{{ $t('t104') }}</p>
        <p class="lbt-content-dark">{{ $t('t105') }}</p>
        <p class="lbt-content">{{ $t('t106') }}</p>
        <p class="lbt-content-dark">{{ $t('t107') }}</p>
        <p class="lbt-content">{{ $t('t108') }}</p>
        <p class="lbt-content-dark">{{ $t('t109') }}</p>
        <p class="lbt-content">{{ $t('t110') }}</p>
        <p class="lbt-content-dark">{{ $t('t111') }}</p>
        <p class="lbt-content">{{ $t('t112') }}</p>
        <p class="lbt-content-dark">{{ $t('t113') }}</p>
        <p class="lbt-content">{{ $t('t114') }}<br/>{{ $t('t115') }}</p>
        <p class="lbt-content-dark">{{ $t('t116') }}</p>
        <p class="lbt-content">{{ $t('t117') }}</p>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Content',
  props: ['lang']
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/airplus_se/content.vue